<template>
  <div>
    <b-modal
      ref="modal"
      scrollable
      :size="modalBModalSize"
      hide-footer
      @show="onShow"
    >
      <template #modal-header>
        <h5 class="modal-title mr-auto">
          <i class="fas fa-circle-nodes mr-2" style="color: #472282"></i>
          Conectores
        </h5>
        <div class="d-flex align-items-center buttons-container">
          <b-button
            v-if="navSelecionada !== 1"
            size="sm"
            variant="light"
            @click="voltarParaListagem"
          >
            Listagem
          </b-button>
          <b-dropdown text="Download Conector" size="sm" variant="info">
            <b-dropdown-item
              href="https://s3.us-east-2.amazonaws.com/media.comunicante.net.br/agente/comunicante-agente-32.zip"
              >Download 32bits</b-dropdown-item
            >
            <b-dropdown-item
              href="https://s3.us-east-2.amazonaws.com/media.comunicante.net.br/agente/comunicante-agente-64.zip"
              >Download 64bits</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            v-if="navSelecionada !== 0"
            size="sm"
            variant="success"
            @click="abrirNovoConector"
          >
            Novo Conector
          </b-button>
          <b-button
            v-if="navSelecionada !== 2"
            size="sm"
            variant="warning"
            @click="redirectNewSystem"
          >
            Novo Sistema
          </b-button>
        </div>
        <b-button variant="link" class="p-0 ml-3" @click="$refs.modal.hide()">
          <i class="fas fa-times fa-lg" style="color: #b5b5c3"></i>
        </b-button>
      </template>

      <div ref="modalContainer">
        <Toast position="top-right" />

        <Transition name="fade" appear :duration="{ enter: 500, leave: 800 }">
          <div v-if="navSelecionada == 0">
            <h2 class="text-center">
              {{ edicaoConector ? "Editar" : "Cadastrar" }} Conector
            </h2>
            <br />
            <form ref="form" @submit.stop.prevent="salvarConector">
              <b-form-group
                label="Descrição"
                label-for="descricao-input"
                invalid-feedback="Descrição é necessária"
              >
                <b-form-input
                  id="descricao-input"
                  v-model="licDescricao"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Status"
                label-for="status-select"
                invalid-feedback="Selecione um status"
              >
                <b-form-select
                  id="status-select"
                  v-model="licStatus"
                  :options="['ATIVO', 'INATIVO', 'SUSPENSO']"
                >
                </b-form-select>
              </b-form-group>

              <b-button
                class="btn-agente-sistema w-100"
                variant="success"
                @click="salvarConector"
                >Salvar</b-button
              >
            </form>
          </div>
          <div v-else-if="navSelecionada == 1">
            <PainelConectores
              ref="painelConectores"
              class="aut-camp-area"
              :contaId="contaId"
              @editar-licenciada="editarLicenciada"
              @editar-conector="editarConector"
            />
          </div>
          <div v-else-if="navSelecionada == 2">
            <CadastroLicenciada
              :cadastro="cadastroLicenciada"
              :licenciadaSelecionadaId="licenciadaSelecionadaId"
              :contaId="contaId"
              @cadastrarEditarLicenciada="atualizarListaLicenciada"
              @redirecionarParaCadastrarAgente="redirecionarParaCadastarAgente"
              @redirectSemMudancas="redirectSistemaSemMudancas"
            />
          </div>
        </Transition>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PainelConectores from "./PainelConectores.vue";
import CadastroLicenciada from "../licenciada/CadastroLicenciada.vue";
import ApiService from "@/core/services/api.service";
import API_LINKS from "../api.links";
import Toast from "primevue/toast/Toast";

export default {
  components: {
    PainelConectores,
    CadastroLicenciada,
    Toast
  },
  data() {
    return {
      contaId: null,
      navSelecionada: 1,
      licDescricao: "",
      licStatus: "",
      licenciadaEdicaoId: null,
      edicaoConector: false,
      cadastroLicenciada: true,
      licenciadaSelecionadaId: null
    };
  },
  methods: {
    // contaId nulo = tela da propria conta logada (usado na Home, ao
    // expandir); com contaId, e a tela daquela conta (Central de Contas).
    abrir(contaId = null) {
      this.contaId = contaId || null;
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },

    onShow() {
      this.navSelecionada = 1;
    },

    voltarParaListagem() {
      this.navSelecionada = 1;
      this.$nextTick(() => {
        this.$refs.painelConectores && this.$refs.painelConectores.pegarDados();
      });
    },

    abrirNovoConector() {
      this.licDescricao = "";
      this.licStatus = "";
      this.licenciadaEdicaoId = null;
      this.edicaoConector = false;
      this.navSelecionada = 0;
    },

    editarConector(item) {
      this.licDescricao = item.lic_descricao;
      this.licStatus = item.lic_status == "A" ? "ATIVO" : "INATIVO";
      this.licenciadaEdicaoId = item.licenciada_id;
      this.edicaoConector = true;
      this.navSelecionada = 0;
    },

    redirectNewSystem() {
      this.navSelecionada = 2;
      this.licenciadaSelecionadaId = null;
      this.cadastroLicenciada = true;
    },
    redirectSistemaSemMudancas() {
      this.navSelecionada = 1;
      this.$toast.add({
        severity: "warn",
        summary: "Sem mudanças",
        detail: "Não houve mudanças no cadastro.",
        life: 7000
      });
    },
    redirecionarParaCadastarAgente() {
      this.abrirNovoConector();
    },
    atualizarListaLicenciada() {
      this.navSelecionada = 1;
      this.$emit("atualizarListagemDeCampanha");
      this.$nextTick(() => {
        this.$refs.painelConectores && this.$refs.painelConectores.pegarDados();
      });
    },
    editarLicenciada(licenciadaId) {
      this.cadastroLicenciada = false;
      this.licenciadaSelecionadaId = licenciadaId;
      this.navSelecionada = 2;
    },
    salvarConector() {
      this.licStatus = this.licStatus[0];
      const emEdicao = !!this.licenciadaEdicaoId;

      const licenca = {
        lic_descricao: this.licDescricao,
        lic_status: this.licStatus
      };

      // O backend (LicenciadaController::atualizar) busca a licenciada por
      // dados.licenciada_id -- sem isso a edicao caia em find(null).
      if (emEdicao) {
        licenca.licenciada_id = this.licenciadaEdicaoId;
      }

      const payload = { licenca };

      // Criando pela Central: sem o conta_id o conector nasceria na conta
      // do super admin, nao na conta que ele esta vendo.
      if (!emEdicao && this.contaId) {
        payload.conta_id = this.contaId;
      }

      ApiService.post(
        API_LINKS.licenca + (emEdicao ? "/" + this.licenciadaEdicaoId : ""),
        payload
      ).then((response) => {
        if (response.data["erro"] != "undefined") {
          this.$toast.add({
            severity: "success",
            summary: "Conector " + (emEdicao ? "atualizado" : "cadastrado"),
            detail: "Você já pode usar o conector nos seus sistemas!",
            life: 7000
          });
        }
        this.atualizarListaLicenciada();
      });
    }
  },
  computed: {
    modalBModalSize() {
      if (window.screen.width > 900) return "xl";
      return "md";
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
// No cabecalho, ao lado do titulo -- sem largura fixa (foi o que quebrava
// "Novo Conector" em duas linhas e dobrava a altura do botao).
.buttons-container {
  gap: 0.5rem;
  white-space: nowrap;
}
</style>
